import React, { useState } from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { CameraAltOutlined } from '@mui/icons-material';
import ImageThumbnail from './ImageThumbnail';
import GalleryViewerSkeleton from './GalleryViewerSkeleton';
import EmptyState from '../../shared/EmptyState/EmptyState';

const GalleryViewer = ({ images, loading }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [activeIndex, setActiveIndex] = useState(0);

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    beforeChange: (current, next) => setActiveIndex(next),
    adaptiveHeight: false,
    arrows: !isMobile,
    fade: true,
    appendDots: dots => (
      <div style={{ bottom: '20px' }}>
        <ul style={{ margin: '0', padding: '0' }}>{dots}</ul>
      </div>
    ),
    customPaging: (i) => (
      <div
        style={{
          width: "10px",
          height: "10px",
          borderRadius: "50%",
          backgroundColor: activeIndex === i ? "#001d3d" : "rgba(255,255,255,0.5)",
        }}
      />
    ),
  };

  if (loading) return <GalleryViewerSkeleton />;
  if (!images?.length) {
    return (
      <EmptyState
        title="No photos available"
        description="The host hasn't uploaded any photos yet."
        illustration={<CameraAltOutlined fontSize="large" />}
      />
    );
  }

  return (
    <Box
      sx={{
        position: "relative",
        borderRadius: "4px",
        overflow: "hidden",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        border: "1px solid #e0e0e0",
        mb: 4,
        backgroundColor: "#f5f5f5",
      }}
    >
      <Slider {...settings}>
        {images.map((img, index) => (
          <Box key={index}>
            <Box
              component="img"
              src={img.url}
              alt={`Room image ${index + 1}`}
              sx={{
                width: '100%',
                height: { xs: 250, sm: 350, md: 450, lg: 500 },
                objectFit: 'cover',
                display: 'block'
              }}
              loading="lazy"
            />
          </Box>
        ))}
      </Slider>

      {!isMobile && images.length > 1 && (
        <Box sx={{
          display: 'flex',
          gap: 1,
          px: 2,
          pb: 2,
          overflowX: 'auto',
          '&::-webkit-scrollbar': {
            height: '6px'
          },
          "&::-webkit-scrollbar-track": { background: "#e0e0e0" },
          "&::-webkit-scrollbar-thumb": { backgroundColor: "#bdbdbd", borderRadius: "3px" },
        }}>
          {images.map((img, index) => (
            <ImageThumbnail
              key={index}
              image={img}
              active={index === activeIndex}
              onClick={() => setActiveIndex(index)}
            />
          ))}
        </Box>
      )}
    </Box>
  );
};

export default GalleryViewer;